<template>
  <div
    class="input_outer"
    :class="[gradient ? 'gradient' : '', elementStyle ? 'is-elem-input' : '']"
    ref="contenteditableInput"
  >
    <el-select
      v-if="sentiment"
      class="yq-template-select"
      size="mini"
      :placeholder="$t('common.Select-Template')"
      v-model="selectedSentimentTemplate"
      @change="onSentimentTemplateChange"
    >
      <el-option v-for="ite in sentimentTemplates" :key="ite.name" :value="ite.content" :label="ite.name"></el-option>
    </el-select>
    <div class="do_reply_message" v-if="replyMessage.length">
      <p class="ellipsis-1-text">{{ replyMessage }}</p>
      <iconfont
        class="pointer"
        icon="mc-icon-guanbi"
        :size="12"
        @click="cancelReplyItem()"
        v-tooltip.right.light.transition="$t('common.Cancel-Reply')"
      ></iconfont>
    </div>
    <div
      class="input-div input-typing-comp-instance"
      :style="{ minHeight: `${height}px` }"
      ref="inputDiv"
      :placeholder="placeholder"
      :contenteditable="contenteditable"
      @keydown="inputKeydown($event)"
      @input="inputting($event)"
      @focus="handleFocus"
      @blur="handleBlur"
      @paste="handlePaste"
    ></div>
    <div class="input-trans-loading" v-if="isTranslating">{{ $t("common.Translating") }}</div>
    <div class="input-trans-loading" v-if="isUploading">{{ $t("common.Uploading") }}</div>
    <div class="fileList" v-if="fileList.length">
      <div class="file-item" v-for="item in fileList" :key="item.pic_osskey">
        <el-image :src="item.pic_url" fit="cover" :preview-src-list="srcList">
          <template v-slot:error>
            <div>
              <i class="el-icon-picture-outline"></i>
            </div>
          </template>
        </el-image>
        <i class="el-icon-error" @click="delFile(item)"></i>
      </div>
    </div>
    <el-divider v-if="inputText.length && inputTextTrans" class="trans-divider">{{ $t("common.Translate-Result") }}</el-divider>
    <div v-if="inputText.length && inputTextTrans" class="input-trans" v-html="inputTextTrans"></div>
    <div class="input-btn-group" v-show="contenteditable">
      <div class="flex-box align-items-center">
        <emojiPopover ref="emojiPopover" v-if="emoji" @select="selectEmoji">
          <icon-btn icon="mc-icon-biaoqing"></icon-btn>
        </emojiPopover>
        <el-upload
          v-if="upload"
          accept="image/*"
          action="#"
          :on-exceed="handleExceed"
          :http-request="handleUpload"
          :before-upload="beforeUpload"
          :show-file-list="false"
        >
          <icon-btn v-if="upload" icon="mc-icon-tupian" style="margin-left: 20px"></icon-btn>
        </el-upload>
      </div>
      <div class="btns">
        <el-popover v-if="translate" ref="translatePopper" placement="top" width="200" trigger="click">
          <popoverLangsComp
            @updatePop="updatePopper"
            @langClick="translateByLang"
            :translatePopperVisible="translatePopperVisible"
          ></popoverLangsComp>
          <template v-slot:reference>
            <el-button class="translate-btn" :disabled="inputText.length === 0" plain round>{{ $t("common.Translate-Reply") }}</el-button>
          </template>
        </el-popover>
        <el-button v-if="inputTextTrans" style="margin-left: 12px" type="primary" round plain @click="transEnter"
          >{{ $t("common.Send-Translation") }}</el-button
        >
        <template v-if="sendable">
          <icon-btn class="icon-send-btn" v-if="gradient" @click="inputEnter" icon="mc-icon-duihuafasong"></icon-btn>
          <el-button v-else class="send-btn" type="primary" @click="inputEnter"
            ><iconfont icon="mc-icon-duihuafasong" style="color: var(--mc-background-main-color)"></iconfont
          ></el-button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import popoverLangsComp from "./popoverLangsComp.vue";
import emojiPopover from "@/components/emojiPopover.vue";
import markdownMixin from "@/mixins/markdownMixin.js";
export default {
  mixins: [markdownMixin],
  components: {
    popoverLangsComp,
    emojiPopover,
  },
  props: {
    sentiment: {
      type: Boolean,
      default: false,
    },
    gradient: {
      default: false,
      type: Boolean,
    },
    elementStyle: {
      default: false,
      type: Boolean,
    },
    height: {
      type: Number,
      default: 20,
    },
    scene: {
      type: Number,
      default: 1, // 1:Messenger客服   2：fb帖文助手  3：邮箱客服  4：知识库 5: 对话 6：设置场景
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    contenteditable: {
      type: Boolean,
      default: true,
    },
    translate: {
      type: Boolean,
      default: true,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    emoji: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    sendable: {
      type: Boolean,
      default: true,
    },
    allowEnterNewline: {
      // 场景配置的回复模板需要保留段落；启用后 Enter 插入换行，发送行为仍由页面按钮处理。
      type: Boolean,
      default: false,
    },
    uploadActionHandler: {
      default() {
        return this.$axios.ImageUpload;
      },
    },
  },
  data() {
    return {
      savedRange: null,
      inputText: "",
      inputTextTrans: "",
      replyMessage: "",
      message_mid: "",
      isTranslating: false,
      isUploading: false,
      fileList: [],
      observer: null,
      translatePopperVisible: false,
      sentimentTemplates: [],
      selectedSentimentTemplate: "",
    };
  },
  computed: {
    srcList() {
      return this.fileList.map((file) => file.pic_url);
    },
  },
  mounted() {
    const observer = new MutationObserver(() => {
      this.updateInputText();
    });
    observer.observe(this.$refs.inputDiv, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    this.observer = observer;

    if (this.sentiment) {
      this.sentimentTemplateList();
    }
  },
  methods: {
    onSentimentTemplateChange() {
      console.log(this.selectedSentimentTemplate);
      if (this.selectedSentimentTemplate) {
        this.inputText = this.selectedSentimentTemplate;
        this.$refs.inputDiv.innerText = this.selectedSentimentTemplate;
      }
    },
    sentimentTemplateList() {
      this.$axios
        .sentimentTemplateList({
          page: 1,
          page_num: 200,
        })
        .then((res) => {
          if (res.code === 1) {
            this.sentimentTemplates = res.data.data;
          }
        });
    },
    updateInputText() {
      this.inputText = this.$refs.inputDiv.innerText;
      this.$emit("input", this.inputText);
    },
    transEnter() {
      this.doSend(this.inputTextTrans);
    },
    translateByLang(lang) {
      this.$refs.translatePopper.showPopper = false;
      this.translatePopperVisible = false;
      if (this.inputText.length === 0) {
        this.inputTextTrans = "";
        return false;
      }

      this.isTranslating = true;
      this.$axios
        .toolTranslate({
          content: this.inputText,
          language: lang.name,
          scene: this.scene,
          cs_id: this.$route.query.id,
        })
        .then((res) => {
          this.isTranslating = false;
          if (res.code === 1) {
            this.inputTextTrans = res.data.translate;
          }
        })
        .catch((err) => {
          this.isTranslating = false;
          console.log(err);
        });
    },
    updatePopper() {
      this.$nextTick(() => {
        this.$refs.translatePopper.updatePopper();
        this.translatePopperVisible = this.$refs.translatePopper.showPopper;
      });
    },
    handlePaste(e) {
      const event = e.originalEvent || e;
      const clipboardItems = Array.from(event.clipboardData?.items || []);
      const imageFiles = clipboardItems
        .filter((item) => item.kind === "file" && item.type.startsWith("image/"))
        .map((item) => item.getAsFile())
        .filter(Boolean);

      if (this.upload && this.contenteditable && imageFiles.length) {
        // 截图和复制图片复用文件选择上传链路，继续遵守 4MB 限制、单图/多图配置及发送前预览。
        e.stopPropagation();
        e.preventDefault();
        const filesToUpload = this.multiple ? imageFiles : imageFiles.slice(0, 1);
        filesToUpload.forEach((file) => {
          if (this.beforeUpload(file)) {
            this.handleUpload({ file });
          }
        });
        return;
      }

      // 非图片粘贴只取纯文本，避免剪贴板中的富文本标签或样式进入输入框。
      e.stopPropagation();
      e.preventDefault();
      let text = "";
      if (event.clipboardData && event.clipboardData.getData) {
        text = event.clipboardData.getData("text/plain");
      } else if (window.clipboardData && window.clipboardData.getData) {
        text = window.clipboardData.getData("text");
      }
      // insertText 会把连续换行变成空的 div，读取 innerText 时会多出换行；用 br 保留原始行数。
      const normalizedText = text.replace(/\r\n?/g, "\n");
      const escapedText = normalizedText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      if (!document.execCommand("insertHTML", false, escapedText.replace(/\n/g, "<br>"))) {
        // 不支持 insertHTML 时插入纯文本节点，避免回退到会增加空行的 insertText。
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        const range = selection.getRangeAt(0);
        range.deleteContents();
        const textNode = document.createTextNode(normalizedText);
        range.insertNode(textNode);
        range.setStartAfter(textNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    // emojiPopover 在触发 select 前自行关闭；这里恢复光标位置并插入对应表情。
    selectEmoji(emoji) {
      console.log(this.savedRange);
      if (this.savedRange) {
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(this.savedRange);
      }
      this.inputFocus(emoji.data, "insert");
    },
    inputting(event) {
      this.inputText = event.target.textContent || event.target.innerText;
      if (!this.inputText) {
        this.inputTextTrans = "";
      }
    },
    replyMidInputFocus(message_text, message_mid) {
      this.replyMessage = message_text;
      this.message_mid = message_mid;
      setTimeout(() => {
        this.$refs.inputDiv.focus();
      }, 0);
    },
    /**
     * @description md 转成 html 取出带格式的纯文本插入输入框
     * @param {String} md 此处进来的肯定时文本字符串，
     * @param {String: 'insert'|'replace'} type 操作方式
     */
    inputFocus(md, type) {
      let valToText = this.MdRevertText(md);
      if (valToText.endsWith(`\n`) || valToText.endsWith(`\r`) || valToText.endsWith(`\r\n`)) {
        valToText = valToText.slice(0, -1);
      }
      const el = this.$refs.inputDiv;
      el.focus();
      // 插入
      if (type === "insert") {
        let sel, range, textBefore, textAfter, content;
        if (window.getSelection) {
          // 标准浏览器
          sel = window.getSelection();
          if (sel.rangeCount) {
            range = sel.getRangeAt(0);
            // 创建两个范围，一个用于获取光标之前的文本，另一个用于获取之后的文本
            const rangeBefore = range.cloneRange();
            rangeBefore.selectNodeContents(el);
            rangeBefore.setEnd(range.startContainer, range.startOffset);
            textBefore = rangeBefore.toString();

            const rangeAfter = range.cloneRange();
            rangeAfter.selectNodeContents(el);
            rangeAfter.setStart(range.endContainer, range.endOffset);
            textAfter = rangeAfter.toString();

            range.deleteContents();

            const textNode = document.createTextNode(valToText);
            range.insertNode(textNode);
            range.setStartAfter(textNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          } else {
            content = el.textContent + valToText;
          }
        } else if (document.selection && document.selection.createRange) {
          range = document.selection.createRange();
          textBefore = range.parentElement().innerText.substring(0, range.boundingStart);
          textAfter = range.parentElement().innerText.substring(range.boundingEnd);
          range.textContent = textBefore + valToText + textAfter;
        }

        this.inputText = el.textContent;

        // this.setCursorToEnd(el);
      } else {
        // 替换 直接将文本框内容替换
        el.innerText = valToText;
        this.inputText = valToText;
        this.setCursorToEnd(el);
      }
    },
    setCursorToEnd(element) {
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(element);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    },
    inputKeydown(e) {
      // 普通聊天输入保持 Enter 发送；回复模板显式开启后让浏览器写入换行节点。
      if (e.keyCode === 13 && !this.allowEnterNewline) {
        if (!e.shiftKey) {
          e.preventDefault();
          this.inputEnter();
          return false;
        }
      }
    },
    inputClear() {
      this.$refs.inputDiv.innerText = "";
      this.inputText = "";
      this.inputTextTrans = "";
      this.replyMessage = "";
      this.fileList = [];
      this.cancelReplyItem();
    },
    async inputEnter() {
      await this.updateInputText();
      const txt = this.inputText;
      this.doSend(txt);
    },
    cancelReplyItem() {
      this.message_mid = "";
      this.replyMessage = "";
    },
    doSend(txt) {
      if (txt || this.srcList.length) {
        this.$emit("send", {
          txt,
          mid: this.message_mid,
          attachment: this.srcList || [],
        });
        this.selectedSentimentTemplate = "";
      }
    },
    delFile(file) {
      this.fileList.splice(this.fileList.indexOf(file), 1);
    },
    handleExceed(files) {
      if (this.multiple) {
        //
      } else {
        this.$message.warning(this.$t("common.Only-One-Image"));
      }
    },
    beforeUpload(file) {
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        this.$message.error(this.$t("common.Image-Max-4MB"));
      }
      return isLt4M;
    },
    handleUpload(param) {
      this.isUploading = true;
      let formData = new FormData();
      formData.append("file", param.file);
      this.uploadActionHandler(formData)
        .then((res) => {
          this.isUploading = false;
          if (res.code == 1) {
            if (this.multiple) {
              this.fileList.push(res.data);
            } else {
              this.fileList = [res.data];
            }
            this.$emit("reciveImages", this.fileList);
          }
        })
        .catch((err) => {
          this.isUploading = false;
        });
    },
    handleFocus() {
      this.$refs.inputDiv.parentElement.classList.add("focused");
    },
    handleBlur() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        this.savedRange = selection.getRangeAt(0);
      }
      this.$refs.inputDiv.parentElement.classList.remove("focused");
    },
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>
<style lang="scss" scoped>
.input_outer {
  padding: 12px;
  background: var(--mc-background-main-color);
  border-radius: 24px;
  border: 1px solid var(--mc-background-main-color);
  position: relative;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.05);
  transition: all var(--mc-transition-duration) var(--mc-transition-timing-function);
  &.focused,
  &:hover {
    border-color: var(--mc-color-primary);
    transition: all var(--mc-transition-duration) var(--mc-transition-timing-function);
  }
  &.gradient {
    position: relative;
    border: none !important;
    &::before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: linear-gradient(270deg, rgba(0, 139, 255, 1), rgba(237, 0, 190, 1));
      z-index: -1;
      border-radius: 26px;
    }
  }
  &.is-elem-input {
    border: 1px solid var(--mc-border-color);
    box-shadow: none;
    border-radius: var(--mc-border-radius-normal);
  }
  .trans-divider {
    margin: 14px 0;
  }
  ::v-deep .yq-template-select {
    width: 100%;
    margin-bottom: 12px;
    margin-top: -10px;
    .el-input {
      .el-input__inner {
        padding-left: 2px;
        border: none;
        border-bottom: 1px solid var(--mc-border-color);
        border-radius: 0;
      }
    }
  }
  .do_reply_message {
    padding: 0 12px;
    height: 32px;
    background: var(--mc-background-secondary-color);
    border-radius: 18px;
    font-family:
      PingFangSC,
      PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: var(--mc-info-text-color);
    line-height: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    > .ellipsis-1-text {
      flex: 1;
    }
  }
  .input-div {
    overflow: auto;
    // 保留纯文本粘贴中的连续空格，以及降级插入的文本节点换行。
    white-space: pre-wrap;
    line-height: 20px;
    min-height: 40px;
    font-size: 14px;
    outline: none;
    font-family: monospace;
    max-height: 200px;
    font-family:
      PingFangSC,
      PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: var(--mc-primary-text-color);
    line-height: 20px;
    text-align: left;
    font-style: normal;
    margin-bottom: 12px;
    &:empty:before {
      content: attr(placeholder);
      color: #b8bfca;
    }
  }
  .input-trans-loading {
    padding: 4px;
    text-align: center;
    color: #909399;
    font-size: 12px;
  }
  .input-trans {
    padding: 4px 0;
    line-height: 20px;
    font-size: 12px;
    font-family: monospace;
    color: #909399;
    max-height: 60px;
    overflow: auto;
  }
  ::v-deep .input-btn-group {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    .btns {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .translate-btn {
        width: 100px;
        height: 44px;
        margin-left: 12px;
      }
      .send-btn {
        margin-left: 12px;
        width: 100px;
        height: 44px;
        background: linear-gradient(270deg, var(--mc-color-primary) 0%, var(--mc-color-primary-gradient) 100%);
        border-radius: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon-send-btn {
        margin-left: 12px;
        .joinmc {
          color: var(--mc-color-primary);
        }
      }
    }
  }
  .fileList {
    display: flex;
    flex-wrap: wrap;
    .file-item {
      width: 50px;
      height: 50px;
      margin: 4px 6px;
      margin-left: 0;
      position: relative;
      .el-image {
        border-radius: 4px;
        height: 100%;
        width: 100%;
      }
      .el-icon-error {
        position: absolute;
        right: -5px;
        top: -5px;
        color: var(--mc-color-primary);
        background-color: var(--mc-background-main-color);
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }
}
</style>
